
import { Link } from "react-router-dom";
import { Guest } from "@/data/mockData";
import { formatDistanceToNow, parseISO } from "date-fns";
import StatusBadge from "./StatusBadge";
import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";

interface GuestCardProps {
  guest: Guest;
}

const GuestCard = ({ guest }: GuestCardProps) => {
  return (
    <Link to={`/guest/${guest.id}`} className="block">
      <Card className="hover:shadow-md transition-shadow overflow-hidden h-full">
        <CardHeader className="p-4 pb-0">
          <div className="flex justify-between items-start">
            <div className="flex gap-3 items-center">
              <Avatar>
                <AvatarImage src={guest.imageUrl} alt={guest.name} />
                <AvatarFallback className="bg-secondary">
                  {guest.name.split(" ").map(n => n[0]).join("")}
                </AvatarFallback>
              </Avatar>
              <div>
                <CardTitle className="text-base font-semibold leading-tight">
                  {guest.name}
                </CardTitle>
                <p className="text-sm text-muted-foreground">
                  {guest.title} at {guest.company}
                </p>
              </div>
            </div>
            <StatusBadge status={guest.status} className="ml-auto" />
          </div>
        </CardHeader>
        <CardContent className="p-4">
          <p className="text-sm line-clamp-2 mb-2 text-muted-foreground">
            {guest.bio}
          </p>
          <div className="flex flex-wrap gap-1 mt-2">
            {guest.topics.slice(0, 3).map((topic, i) => (
              <span
                key={i}
                className="text-xs px-2 py-0.5 bg-secondary rounded-full"
              >
                {topic}
              </span>
            ))}
            {guest.topics.length > 3 && (
              <span className="text-xs px-2 py-0.5 bg-secondary/50 rounded-full">
                +{guest.topics.length - 3} more
              </span>
            )}
          </div>
          {guest.scheduledDate && (
            <div className="text-xs text-muted-foreground mt-3">
              Scheduled{" "}
              {formatDistanceToNow(parseISO(guest.scheduledDate), {
                addSuffix: true,
              })}
            </div>
          )}
        </CardContent>
      </Card>
    </Link>
  );
};

export default GuestCard;
